'use client';

import { c as _c } from "react/compiler-runtime";
import { Icon } from '@udemy-v2/icons';
import { LocalizedHtml, useI18n } from '@udemy-v2/i18n';
import styles from './blended-offer-badge.module.scss';
export interface BlendedOfferBadgeProps {
  variant: 'monthly' | 'annual';
  termsUrl?: string;
  onLifetimeAccessClick: () => void;
}
export const BlendedOfferBadge = t0 => {
  const $ = _c(15);
  const {
    variant,
    termsUrl,
    onLifetimeAccessClick
  } = t0;
  const {
    gettext
  } = useI18n();
  let t1;
  if ($[0] !== gettext || $[1] !== variant) {
    t1 = variant === "monthly" ? gettext("<span class=\"emphasis\">Get</span> <span class=\"lifetime-access-link\">lifetime access</span> to this course for free after your first Personal Plan renewal. <span class=\"terms-link\">Terms apply</span>") : gettext("<span class=\"emphasis\">Get</span> <span class=\"lifetime-access-link\">lifetime access</span> to this course for free with an annual Personal Plan subscription. <span class=\"terms-link\">Terms apply</span>");
    $[0] = gettext;
    $[1] = variant;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const html = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Icon className={styles["value-prop-icon"]} glyph="verified" color="positive" size="small" label="" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className={styles.emphasis} />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onLifetimeAccessClick) {
    t4 = <button type="button" className={styles["lifetime-access-link"]} onClick={onLifetimeAccessClick} data-purpose="blended-offer-lifetime-access-link" />;
    $[5] = onLifetimeAccessClick;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== termsUrl) {
    t5 = termsUrl ? <a href={termsUrl} target="_blank" rel="noopener noreferrer" className={styles["terms-link"]} data-purpose="blended-offer-terms-link" /> : <span />;
    $[7] = termsUrl;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = {
      emphasis: t3,
      "lifetime-access-link": t4,
      "terms-link": t5
    };
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== html || $[13] !== t6) {
    t7 = <div className={styles["value-prop-badge"]} data-purpose="blended-offer-badge">{t2}<span className={styles["value-prop-text"]}><LocalizedHtml html={html} interpolate={t6} /></span></div>;
    $[12] = html;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};